import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
// 分屏
import '../../assets/styles/jquery.fullpage.min.css'
import '../../assets/scripts/jquery.fullpage.min.js'
$("#nav1").addClass("active");

var interleaveOffset = 0.5; //视差比值
var swiperOptions = {
    loop: true,
    speed: 1000,
    grabCursor: true,
    watchSlidesProgress: true,
    mousewheelControl: true,
    keyboardControl: true,
    autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
    },
    pagination: {
        el: "#banner-swiper .swiper-pagination",
        clickable: true,
    },
    on: {
        progress: function (swiper) {
            for (var i = 0; i < swiper.slides.length; i++) {
                var slideProgress = swiper.slides[i].progress;
                var innerOffset = swiper.width * interleaveOffset;
                var innerTranslate = slideProgress * innerOffset;
                swiper.slides[i].querySelector("#banner-swiper .swiper-slide img").style.transform =
                    "translate3d(" + innerTranslate + "px, 0, 0)";
            }
        },
        touchStart: function (swiper) {
            for (var i = 0; i < swiper.slides.length; i++) {
                swiper.slides[i].style.transition = "";
            }
        },
        setTransition: function (swiper, speed) {
            for (var i = 0; i < swiper.slides.length; i++) {
                swiper.slides[i].style.transition = speed + "ms";
                swiper.slides[i].querySelector("#banner-swiper .swiper-slide img").style.transition =
                    speed + "ms";
            }
        },
    },
    
};
var swiper = new Swiper("#banner-swiper", swiperOptions);
// 关于我们数字滚动

//窗口显示才加载
var wrapTop = $(".page2_bg").offset().top;
console.log(wrapTop);
var istrue = true;
$(window).on("scroll",
function() {
    var s = $(window).scrollTop();
    if (s > wrapTop - 500 && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})
//设置计数
$.fn.countTo = function (options) {
    options = options || {};
    return $(this).each(function () {
        //当前元素的选项
        var settings = $.extend({}, $.fn.countTo.defaults, {
            from:            $(this).data('from'),
            to:              $(this).data('to'),
            speed:           $(this).data('speed'),
            refreshInterval: $(this).data('refresh-interval'),
            decimals:        $(this).data('decimals')
        }, options);
        //更新值
        var loops = Math.ceil(settings.speed / settings.refreshInterval),
            increment = (settings.to - settings.from) / loops;
        //更改应用和变量
        var self = this,
        $self = $(this),
        loopCount = 0,
        value = settings.from,
        data = $self.data('countTo') || {};
        $self.data('countTo', data);
        //如果有间断，找到并清除
        if (data.interval) {
            clearInterval(data.interval);
        };
        data.interval = setInterval(updateTimer, settings.refreshInterval);
        //初始化起始值
        render(value);
        function updateTimer() {
            value += increment;
            loopCount++;
            render(value);
            if (typeof(settings.onUpdate) == 'function') {
                settings.onUpdate.call(self, value);
            }
            if (loopCount >= loops) {
                //移出间隔
                $self.removeData('countTo');
                clearInterval(data.interval);
                value = settings.to;
                if (typeof(settings.onComplete) == 'function') {
                    settings.onComplete.call(self, value);
                }
            }
        }
        function render(value) {
            var formattedValue = settings.formatter.call(self, value, settings);
            $self.html(formattedValue);
        }
        });
    };
    $.fn.countTo.defaults={
        from:0,               //数字开始的值
        to:0,                 //数字结束的值
        speed:1000,           //设置步长的时间
        refreshInterval:100,  //隔间值
        decimals:0,           //显示小位数
        formatter: formatter, //渲染之前格式化
        onUpdate:null,        //每次更新前的回调方法
        onComplete:null       //完成更新的回调方法
    };
    function formatter(value, settings){
        return value.toFixed(settings.decimals);
    }
    //自定义格式
    $('#count-number').data('countToOptions',{
        formmatter:function(value, options){
            return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
        }
    });
    //定时器
    $('.timer').each(count);
    function count(options){
        var $this=$(this);
        options=$.extend({}, options||{}, $this.data('countToOptions')||{});
        $this.countTo(options);
    }

    $(function(){
        $('#dowebok').fullpage({
            navigation:true,
            verticalCentered:false,
            css3: false,
            scrollingSpeed:800,
            slidesNavigation:false,
    
            anchors: ['page1', 'page2','page3','page4','page5','page6'],
            menu: '#menu',
            autoScrolling: true,
            //anchors: ['hero', 'services', 'cases', 'news','about','contact','footer']
            
            afterLoad: function(anchorLink, index)
            {
                if(index == 1)
                {
                    $("header").removeClass("head1");
                }
                if(index == 2)
                {
                    $("header").addClass("head1");
                    
                    $(".timer").each(count);
                    function count(a) {
                        var b = $(this);
                        a = $.extend({},
                        a || {},
                        b.data("countToOptions") || {});
                        b.countTo(a)
                    };
                    istrue = false;
                }
                if(index == 3)
                {		
                    $("header").addClass("head1");
                }
                if(index == 4)
                {		
                    $("header").addClass("head1");
                }
                if(index == 5)
                {		
                    $("header").addClass("head1");
                }
                if(index == 6)
                {
                    $("header").addClass("head1");
                }
                if(index == 7)
                {
                    $("header").addClass("head1");
                }
            },
        
    
        });
        $(window).resize(function(){
            autoScrolling();
        });
        /*手机上不滚动*/
        function autoScrolling(){
            var $ww = $(window).width();
            if($ww < 1024){
                $.fn.fullpage.setAutoScrolling(false);
                $.fn.fullpage.setFitToSection(false);
            } else {
                $.fn.fullpage.setAutoScrolling(true);
            }
        }
        autoScrolling();
    });
    

// 视频
$(".play").click(function () {
    var video = document.getElementById('myVideo');
    if (video.paused) { //如果已暂停则播放
        $('.play').hide();
        video.play(); //播放控制
    } else { // 已播放点击则暂停
        $('.play').show();
        video.pause(); //暂停控制
    }
})
// 业务领域
$(".section2 ul li").hover(function() {
    $(".section2 ul li").removeClass("active")
    $(".section2 ul li").removeClass("active1")
    $(this).addClass("active").siblings().addClass("active1");
})
$(".section2").mouseleave(function() {
    $(".section2 ul li").removeClass("active")
    $(".section2 ul li").removeClass("active1")
})
// 核心竞争力
$(".section3 ul li").eq(2).addClass("active")
$(".core-text .text").eq(2).addClass("active")
$(".section3 ul li").hover(function () {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".core-text .text").eq(index).addClass("active").siblings().removeClass("active");
})


